module.exports = __webpack_public_path__ + "img/pijltjes-contactpersoon.e699897fa374c8e2312b2906bca75353.svg";